import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { CHECKLISTS } from '../../../locales/pages/namespaces';

const sections = [
  {
    titleKey: 'cleaning_instruction_daily_title',
    items: [
      { number: '1', key: 'cleaning_instruction_daily_1' },
      { number: '1.1', key: 'cleaning_instruction_daily_1_1' },
      { number: '2', key: 'cleaning_instruction_daily_2' },
      { number: '3', key: 'cleaning_instruction_daily_3' },
      { number: '3.1', key: 'cleaning_instruction_daily_3_1' },
      { number: '3.2', key: 'cleaning_instruction_daily_3_2' },
      { number: '3.3', key: 'cleaning_instruction_daily_3_3' },
      { number: '3.4', key: 'cleaning_instruction_daily_3_4' },
      { number: '3.5', key: 'cleaning_instruction_daily_3_5' },
      { number: '3.6', key: 'cleaning_instruction_daily_3_6' },
      { number: '3.7', key: 'cleaning_instruction_daily_3_7' },
      { number: '4', key: 'cleaning_instruction_daily_4' },
      { number: '5', key: 'cleaning_instruction_daily_5' },
      { number: '6', key: 'cleaning_instruction_daily_6' },
      { number: '7', key: 'cleaning_instruction_daily_7' },
      { number: '8', key: 'cleaning_instruction_daily_8' },
      { number: '9', key: 'cleaning_instruction_daily_9' },
      { number: '10', key: 'cleaning_instruction_daily_10' },
      { number: '11', key: 'cleaning_instruction_daily_11' },
      { number: '12', key: 'cleaning_instruction_daily_12' },
      { number: '13', key: 'cleaning_instruction_daily_13' },
      { number: '14', key: 'cleaning_instruction_daily_14' },
      { number: '15', key: 'cleaning_instruction_daily_15' },
      { number: '16', key: 'cleaning_instruction_daily_16' },
      { number: '17', key: 'cleaning_instruction_daily_17' }
    ]
  },
  {
    titleKey: 'cleaning_instruction_weekly_title',
    items: [
      { number: '18', key: 'cleaning_instruction_weekly_18' },
      { number: '19', key: 'cleaning_instruction_weekly_19' },
      { number: '20', key: 'cleaning_instruction_weekly_20' },
      { number: '21', key: 'cleaning_instruction_weekly_21' },
      { number: '22', key: 'cleaning_instruction_weekly_22' }
    ]
  },
  {
    titleKey: 'cleaning_instruction_monthly_title',
    items: [
      { number: '23', key: 'cleaning_instruction_monthly_23' },
      { number: '24', key: 'cleaning_instruction_monthly_24' },
      { number: '25', key: 'cleaning_instruction_monthly_25' },
      { number: '26', key: 'cleaning_instruction_monthly_26' },
      { number: '27', key: 'cleaning_instruction_monthly_27' },
      { number: '28', key: 'cleaning_instruction_monthly_28' },
      { number: '29', key: 'cleaning_instruction_monthly_29' },
      { number: '30', key: 'cleaning_instruction_monthly_30' }
    ]
  },
  {
    titleKey: 'cleaning_instruction_quarterly_title',
    items: [
      { number: '31', key: 'cleaning_instruction_quarterly_31' },
      { number: '32', key: 'cleaning_instruction_quarterly_32' },
      { number: '33', key: 'cleaning_instruction_quarterly_33' },
      { number: '34', key: 'cleaning_instruction_quarterly_34' }
    ]
  },
  {
    titleKey: 'cleaning_instruction_annual_title',
    items: [
      { number: '35', key: 'cleaning_instruction_annual_35' },
      { number: '36', key: 'cleaning_instruction_annual_36' }
    ]
  },
  {
    titleKey: 'cleaning_instruction_special_title',
    items: [
      { number: '37', key: 'cleaning_instruction_special_37' },
      { number: '38', key: 'cleaning_instruction_special_38' },
      { number: '39', key: 'cleaning_instruction_special_39' },
      { number: '40', key: 'cleaning_instruction_special_40' },
      { number: '41', key: 'cleaning_instruction_special_41' },
      { number: '42', key: 'cleaning_instruction_special_42' }
    ]
  }
];

const CleaningInstructionList = () => {
  const { t } = useTranslation(CHECKLISTS);

  return (
    <Box sx={{ mt: 2, p: 2, borderRadius: 2, backgroundColor: '#f7f5fb', border: '1px solid #e2dff0' }}>
      {/*<Typography variant="h6" sx={{ mb: 2, fontWeight: 700 }}>*/}
      {/*  {t('cleaning_instruction_header')}*/}
      {/*</Typography>*/}
      {sections.map((section) => (
        <Box key={section.titleKey} sx={{ mb: 3 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1.5 }}>
            {t(section.titleKey)}
          </Typography>
          {section.items.map((item) => (
            <Box key={`${section.titleKey}-${item.number}`} sx={{ mb: 1.5 }}>
              <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 600 }}>
                {item.number}. {t(item.key)}
              </Typography>
            </Box>
          ))}
        </Box>
      ))}
    </Box>
  );
};

export default CleaningInstructionList;
